import {
  Cancel01Icon,
  Delete03Icon,
  StatusIcon,
  UserCircle02Icon
} from "@hugeicons-pro/core-stroke-rounded";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { RowSelectionState } from "@tanstack/react-table";
import { instance } from "api/apiBase";
import { toast } from "react-toastify";
import {
  Button,
  ButtonSize,
  ButtonVariant,
  IconButton,
  IconButtonSize,
  IconButtonVariant
} from "shared/components";

export const SelectPopUp = ({
  selectedRow,
  clearSelectedRows
}: {
  selectedRow: RowSelectionState;
  clearSelectedRows: () => void;
}) => {
  const queryClient = useQueryClient();
  const { mutateAsync: deleteLeads, isPending } = useMutation({
    mutationKey: ["BULK", "DELETE", "LEADS"],
    onSuccess: (_, variables) => {
      clearSelectedRows();
      queryClient.refetchQueries({ queryKey: ["LEADS_TABLE"] });
      toast.success(
        `${variables.length} ${variables.length > 1 ? "leads" : "lead"} deleted successfully`
      );
    },
    mutationFn: async (lead_ids: number[]) => {
      return instance.delete(`/portal/v1/leads/bulk_delete`, {
        data: {
          lead_ids
        }
      });
    }
  });

  const ammountOfSelectedLeads =
    Object.values(selectedRow).filter(Boolean).length;

  return Object.values(selectedRow).filter(Boolean).length ? (
    <div className="h-16 divide-x-[1px] shadow-lg bg-white px-4 py-2 rounded-lg border border-alpha-100 z-[11] fixed right-10 bottom-24 animate-appear flex justify-end items-center gap-4">
      <p className="text-base font-medium text-content-1000 truncate">
        {ammountOfSelectedLeads} {ammountOfSelectedLeads > 1 ? "leads" : "lead"}{" "}
        selected
      </p>

      <Button
        size={ButtonSize.SM}
        HugeIcon={UserCircle02Icon}
        variant={ButtonVariant.TEXT}
        onClick={() => alert("wip")}
        className="flex items-center justify-center gap-2 pl-4"
      >
        Assign
      </Button>
      <Button
        size={ButtonSize.SM}
        HugeIcon={StatusIcon}
        variant={ButtonVariant.TEXT}
        onClick={() => alert("wip")}
        className="flex items-center justify-center gap-2 pl-4"
      >
        Change stage
      </Button>
      <Button
        size={ButtonSize.SM}
        HugeIcon={Delete03Icon}
        loading={isPending}
        variant={ButtonVariant.TEXT}
        className="flex items-center justify-center gap-2 pl-4"
        onClick={() => deleteLeads(Object.keys(selectedRow).map(Number))}
      >
        Delete
      </Button>

      <div className="pl-4 h-5 flex flex-shrink-0 items-center">
        <IconButton
          size={IconButtonSize.SM}
          variant={IconButtonVariant.TEXT_BASE}
          HugeIcon={Cancel01Icon}
          onClick={clearSelectedRows}
        />
      </div>
    </div>
  ) : null;
};
